import React, { useEffect, useState } from 'react';
import logo from '../../assest/logo.svg';
import '../../csscomponent/AppSplashScreen.css';

export default function AppSplashScreen({ onFinish }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    // Smooth cinematic transition: give user 2.3 seconds to enjoy branding
    const exitTimer = window.setTimeout(() => {
      setExiting(true);
    }, 2300);

    // Completely unmount splash after smooth fade-out (~2.7s)
    const doneTimer = window.setTimeout(() => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    }, 2700);

    return () => {
      window.clearTimeout(exitTimer);
      window.clearTimeout(doneTimer);
    };
  }, [onFinish]);

  const handleSkip = () => {
    setExiting(true);
    window.setTimeout(() => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    }, 200);
  };

  return (
    <div
      className={`netflix-splash-overlay ${exiting ? 'exiting' : ''}`}
      onClick={handleSkip}
      role="button"
      tabIndex={0}
      aria-label="Skip splash screen"
    >
      <div className="netflix-splash-ambient" />
      <div className="netflix-splash-ambient-gold" />

      <div className="netflix-splash-content">
        <div className="netflix-splash-logo-wrap">
          <img src={logo} alt="Services and Developer logo" className="netflix-splash-logo" />
          <span className="netflix-splash-sheen" aria-hidden="true" />
        </div>

        <div className="netflix-splash-text-block">
          <h1 className="netflix-splash-title">Services and Developer</h1>
          <p className="netflix-splash-sub">Modern Digital Solutions</p>
        </div>
      </div>

      <span className="netflix-splash-skip">Tap to skip</span>
    </div>
  );
}
